document.addEventListener('DOMContentLoaded', function () {
    const mobileMenuToggle = document.querySelector('.mobile-i-button');
    const navWrapper = document.querySelector('.the-nav');
    const parentNavMenuItems = document.querySelectorAll('.menu-item-has-children');
    let parentNavLinks = document.querySelectorAll('.menu-item-has-children > a');

    mobileMenuToggle.addEventListener('click', function () {
        document.body.classList.toggle('disable-scroll');

        this.classList.toggle('ion-navicon-round');
        this.classList.toggle('ion-close-round');

        navWrapper.classList.toggle('bg');
        navWrapper.classList.toggle('mobile-menu-open');

        if (!navWrapper.classList.contains('mobile-menu-open')) {
            this.blur();
        }
    });

    parentNavMenuItems.forEach(item => {
        item.addEventListener('click', function (e) {
            if (navWrapper.classList.contains('mobile-menu-open')) {
                if(e.target.parentElement.classList.contains('menu-item-has-children')) {
                    e.preventDefault();
                }  
                item.classList.toggle('open-dropdown');
            }
        });

        let subMenu = item.querySelector('.sub-menu');
        let parentNavLink = item.firstChild.cloneNode(true);
        parentNavLink.classList.add('parent-nav-item-mobile');

        subMenu.insertBefore(parentNavLink, subMenu.firstChild)
        
    })

    
    // parentNavLinks.forEach(item => {
    //     console.log(item)
    //     let subMenu = item.closest('.sub-menu');
    //     subMenu.insertBefore(item.cloneNode(true), subMenu.firstChild);

    // })
    

    window.addEventListener('scroll', function () {
        if (topOfPage()) {
            navWrapper.classList.add('at-the-top');
        } else {
            navWrapper.classList.remove('at-the-top');
        }
    });

    window.addEventListener('resize', function (event) {
        document.body.classList.remove('disable-scroll');
        mobileMenuToggle.classList.remove('ion-close-round');
        mobileMenuToggle.classList.add('ion-navicon-round');
        navWrapper.classList.remove('bg');
        navWrapper.classList.remove('mobile-menu-open');

        parentNavMenuItems.forEach(item => {
            item.classList.remove('open-dropdown');
        })
    });

    function topOfPage() {
        if ($(window).scrollTop() <= 10) {
            return true;
        } else {
            return false;
        }
    }
});